<template>
  <div class="app">
    <v-app-bar clipped-left app dark dense color="bluePcm">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="ml-n3" />

      <ClientNameAppbar />
      <AppBar />
    </v-app-bar>

    <v-navigation-drawer
      clipped
      :permanent="$vuetify.breakpoint.mdAndUp"
      app
      :mini-variant="!drawer"
      :mini-variant-width="$vuetify.breakpoint.mdAndUp ? '70' : ''"
      color="background"
      v-model="drawer"
    >
      <ListNavigationDrawerUser />
    </v-navigation-drawer>
  </div>
</template>

<script>
import ClientNameAppbar from "@/componentes/ClientNameAppbar";
import AppBar from "@/componentes/AppBar";

// import AppBarUser from "./AppBarUser";
import ListNavigationDrawerUser from "./ListNavigationDrawerUser";

export default {
  name: "navigationDrawerMediumAndUp",
  components: { ClientNameAppbar,  ListNavigationDrawerUser, AppBar },
  data: () => ({
    drawer: false,
  }),
};
</script>

<style>
.app {
  background-color: var(--v-background-base);
}
</style>
